export default {
  weeklyCheckIn: {
    fullAttendanceReward: 'Full Attendance Reward',
    achieved: 'Achieved',
    completed: 'Completed',
  },
  share: {
    copyFailed: 'Copy failed. Please try again.',
  },
  loading: 'Loading...',
  'no-update': 'Already the latest version',
  'load-more': 'Load More',
  'copy-success': 'Copy Successfully',
  'invalid-url': 'Invalid Url',
  'download-unavailable': 'The download link is temporarily unavailable',
  home: {
    hotgame: {
      title: 'Hot Game',
      titleRight: 'The most popular games',
      dice: 'DICE',
      maxOdds: 'MAX ODDS',
      color: 'COLOR',
      quick3d: 'QUICK 3D',
      racecar: 'RACECAR',
    },
    tab: {
      home: 'Home',
      result: 'Result',
      casino: 'Casino',
      scratch: 'Scratch',
      scratchOff: 'Scratch Off',
      referral: 'Referral',
      me: 'Me',
      live: 'Live',
      liveCasino: 'Live Casino',
      sports: 'Sports',
      lottery: 'Lottery',
      promotions: 'Promotions',
      invite: 'Invite',
      wallet: 'Wallet',
      proxyhome: 'Agent',
      hot: 'Hot',
      rules: 'rules',
      agentBenefits: 'Agent Benefits',
      agentExtraCommission: 'Agent Extra Commission',
      context:
        'Note: Even if you don’t reach Gold, Diamond, Platinum Level you’ll still receive 2% additional commission when you have 30 active users on your 1st level.',
    },
    scratch: {
      title: 'Scratch',
      free: 'FREE',
    },
    kerala: {
      title: 'Kerala State',
      no: 'NO.',
      lastResult: 'Last Jackpot Outcome',
    },
    digit: {
      title: '3 Digit Game',
      booking: 'Time for Next Booking',
      ticket: 'Ticket',
      price: 'Ticket Price',
      lastResult: 'Last Draw Outcome',
      drawTime: 'Next Draw Time',
    },
    dice: {
      title: 'Dice Game',
      play: 'Play Now',
    },
    color: {
      title: 'Color Prediction',
    },
    matka: {
      bid: 'BID',
      win: 'WIN',
      OPEN: 'OPEN',
      CLOSE: 'CLOSE',
      open: 'Open',
      close: 'Close',
      title: 'Satta Matka',
    },
    'live-casino': {
      title: 'Live Casino',
    },
    car: {
      title: 'Quick Race',
      min: 'min',
      text: 'Next draw starts in',
    },
    tip: {
      closed: '{{name}} is closed now, please choose next game',
      copied: 'Copy successfully, please share with friends',
    },
    label: {
      menu: 'Menu',
      viewAll: 'View All',
      buyNow: 'Buy Now',
      'lucky-spin': 'Lucky Spin',
      rebate: 'Rebate',
      'free-lottery': 'Free Lottery',
      referral: 'Referral',
      'refer-friend': 'Refer Friend',
      agent: 'Agent',
      biggestWins: 'Biggest Wins',
      jackpotGames: 'Jackpot Games',
      onlineUser: '{{number}} users playing',
      popularGame: 'The most popular game',
      provedores: 'Provedores',
      allGames: 'All Games',
      more: 'More',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      seconds: 'Seconds',
      total: 'Total',
      bet: 'Bet',
      online: 'Online',
      winningAmount: 'Winning Amount',
      imgFail: 'Image failed to load',
      userPlay: 'Users Playing',
      availOutcomes: '{{count}} Available Outcomes',
      rechargeWeekCard: 'Go buy',
      spinActual: 'Loot Spin',
    },
    luckyspin: {
      add: 'Add',
      spin: 'SPIN',
      won: 'Won',
      winner: 'Big Winners',
      mySpin: 'My Spin',
    },
    title: {
      scratchOff: 'Scratch Off',
      casino: 'Casino',
      live: 'Live',
      sports: 'Sports',
      lottery: 'Lottery',
      scratch: 'Scratch',
      servertime: 'Server Uptime Days',
      winningInformation: 'Winning Information',
      todayEarningsChart: "Today's earnings chart",
    },
  },
  casino: {
    sortby: 'Sort by',
    categories: 'Categories',
    popular: 'Popular',
    all: 'All',
    lobby: 'Lobby',
  },
  me: {
    webview: {
      vip: 'Member Center',
    },
    new: 'NEW',
    user: {
      userId: 'User ID',
      moreExciting: 'More exciting after logging in',
      login: 'Log in',
      loginUpper: 'LOGIN',
      uid: 'UID:',
      lastLogin: 'Last login:',
    },
    money: {
      totalWallet: 'Total Wallet',
      myWallet: 'My Wallet',
      cashBalance: 'Cash Balance',
      withdrawAmount: 'Withdrawable Amount',
      totalBalance: 'Total balance',
      wallet: 'Wallet',
      recharge: 'Recharge',
      withdraw: 'Withdraw',
    },
    vip: {
      recharge: 'Recharge',
      move: 'more to reach level',
    },
    bottom: {
      recharge: 'Recharge',
      withdraw: 'Withdraw',
      transfer: 'Transfer',
      proxy: 'Agency Center',
      logout: 'LOG OUT',
      resultHistory: 'Result history',
      myBets: 'My Bets',
      myTransactions: 'My Transactions',
      commission: 'My Commission',
      notify: 'Notifications',
      lang: 'Languages',
      customer: 'Customer service',
      update: 'Update',
      password: 'Password',
      gifCode: 'Gift Code',
    },
    language: {
      switch: 'Switch Language',
      english: 'English',
    },
    tip: {
      cashTitle: 'Cash Balance:',
      cashContent:
        '"Cash balance" refers to the actual cash funds available in your account that can be used for betting or other transactions.',
      withdrawTitle: 'Withdrawable Amount:',
      withdrawContent:
        '"Withdrawable amount" is the portion of your cash balance that can be withdrawn from your account. It represents the money that has met the wagering requirements, which need to be fulfilled before the funds can be withdrawn.',
      dailyRewards: 'Exciting rewards await, act now!',
      bonus: 'Win <0>free</0> prizes, claim your reward now!',
      anyquery: 'For any queries and complaints please email us',
    },
  },
  invitation: {
    referEarn: {
      cashEverydayTitle: 'Cash {{amount}} Everyday',
    },
    title: {
      singUp: 'Free lottery tickets',
    },
    label: {
      claim: 'Claim your Ticket',
    },
    bind_phone: {
      btn: 'Go to Bind',
      title: 'Phone number not bound',
      tip: 'To protect your rewards, please bind your mobile number before becoming an agent.',
    },
    getcode: {
      btn: 'Get Code',
      title: 'Please enter your phone number',
      tip: 'Please enter your phone number',
    },
    apply: {
      phoneNumber: 'Phone number',
      otp: 'OTP',
      send: 'Send',
      logIn: 'Log In',
      autoRegisterLine1:
        'If you do not have an account, it will be automatically',
      autoRegisterLine2: 'registered for you',
      registrationSuccess: 'Registration Success',
      downloadApp: 'Download the app',
      loginToReceiveGifts: 'and log in to receive gifts',
      download: 'Download',
    },
    home: {
      'first-charge': 'First charge',
      recharge: 'Recharge',
      'game-column': 'Game',
      'commission-rate-column': 'Game Rebate',
      'commission-rate-title': 'Game Rebate',
      'game-rebate-title': 'Game Rebate',
      'level-commission': 'Level {{level}} Commission',
      'game-rebate-design-description-pick11':
        'Each time your invited member plays a game in Pick11, you receive a commission of5% of the entry amount for each contest.',
      'game-rebate-design-description-rummy':
        'Rummy games share a commission for 1% of each game played by your invitedmembers',
      bouns: 'Bonus',
      invites: 'Invites',
      recharges: 'Recharges',
      deposit: 'Deposit',
      completed: 'Completed',
      'go-complete': 'Go Complete',
      income: 'Total Income',
      count: 'Invited Friends',
      join: 'Join Refer & Earn',
      'join-tip': 'Invite friends to unlock more rewards',
      record: 'Records',
      'reward-rules': 'Reward Rules',
      rules: 'Rules',
      inviteGet: 'Invite {{count}} friends to get:',
      'code-title': 'My invitation code',
      'complete-task-prefix': 'Complete the task to get',
    },
    myData: {
      filters: {
        yesterday: 'Yesterday',
        today: 'Today',
        threeDays: '3 Days',
        week: 'This Week',
        fifteenDays: '15 Days',
        month: 'This Month',
        lottery: 'State Lottery',
      },
      teamAData: 'Team A Data:',
      dashboard: 'Data Dashboard:',
      metrics: {
        members: 'Members',
        firstDeposits: 'First Deposits',
        deposits: 'Deposits',
        depositAmount: 'Deposit Amount',
        firstDepositAmount: 'First Deposit Amount',
        inviteBonus: 'Invite Bonus',
        withdraw: 'Withdraw',
        depositBonus: 'Deposit Bonus',
        commission: 'Commission',
        betAmounts: 'Bet Amounts',
        allTeam: 'All Team',
        teamA: 'Team A',
        otherTeam: 'Other Team',
        allBonus: 'All Bonus',
      },
      dashboardCards: {
        teamMembers: 'My Team Members',
        bonus: 'Bonus',
        betAmounts: 'Bet Amounts',
        betCommission: 'Bet Commission',
      },
    },
    agentData: {
      noData: 'No data',
    },
    subordinateData: {
      dateRange: '06/04/2026-06/04/2026',
      searchPlaceholder: 'Input user ID to search',
      columns: {
        userId: 'User ID',
        team: 'Team',
        superiorId: 'Superior ID',
        createTime: 'Create Time',
      },
    },
    depositBonus: {
      searchPlaceholder: 'Input user ID to search',
      columns: {
        userId: 'User ID',
        depositAmount: 'Deposit Amount',
        depositType: 'Deposit Type',
        bonusRate: 'Bonus Rate',
        bonus: 'Bonus',
        depositTime: 'Deposit Time',
      },
      types: {
        firstRecharge: 'First Deposit',
        first_recharge: 'First Deposit',
        FIRST_RECHARGE: 'First Deposit',
        recharge: 'Deposit',
        RECHARGE: 'Deposit',
      },
    },
    commission: {
      dateRange: '06/04/2026-06/04/2026',
      columns: {
        userId: 'User ID',
        team: 'Team',
        betAmounts: 'Bet Amounts',
        commission: 'Commission',
      },
    },
    referral: {
      title: 'Refer & Earn',
      loginNow: 'Login Now',
      totalUsers: 'Total Users',
      totalCommission: 'Total Commission',
      inviteNow: 'Invite Now',
      shareUnavailable: 'Unable to prepare share link. Please try again.',
      levelUp: 'Agent level up',
      levelUpTable: {
        agentLevel: 'Agent\nLevel',
        teamMember: 'Team Member',
        teamDeposit: 'Team Deposit',
      },
      tabs: {
        invite: 'Invite',
        myData: 'My Data',
        subordinate: 'Subordinate',
        depositBonus: 'Deposit Bonus',
        commission: 'Commission',
      },
      rulesModal: {
        title: 'Reward Rules',
        content:
          'Invite friends to register, deposit, and play games. You can receive invite rewards, deposit bonuses, and game commission according to the rule table.',
      },
      betCommission: {
        title: 'Bet Commission',
        description:
          'Your commissions are split by spending your team. The higher your agent level, the greater your rebate amount.',
        note: 'When your Infinite Range Referral Team(TeamA-...-TeamD) meet the required valid bet amounts, your agent level will increase. The higher agent level you are, the higher bet commission you will be.',
        table: {
          agent: 'Agent',
          level: 'Level',
          teamA: 'teamA',
          teamB: 'teamB',
          teamC: 'teamC',
          teamD: 'teamD',
        },
      },
      rechargeRebate: {
        title: 'Recharge Rebate',
        table: {
          deposit: 'Deposit',
          level1: 'Level 1',
          level2: 'Level 2',
          level3: 'Level 3',
          level4: 'Level 4',
        },
      },
      team: {
        title: 'Description of Agent Levels',
        levels: {
          you: 'You',
          referralA: 'A → You: A is your LV1 Refer',
          referralB: 'B → You: B is your LV2 Refer',
          referralC: 'C → You: C is your LV3 Refer',
          referralD: 'D → You: D is your LV4 Refer',
          description:
            'You can earn commission from your downline network up to 4 levels. Receive a percentage of all bets made by your referrals in Levels A, B, C and D. Check the below chart for detailed commission rates.',
        },
      },
      faq: {
        title: 'FAQ',
        how: 'How do I receive rewards?',
        howAnswer:
          "Once your friends or your friends' invitations make purchases,\nyou will immediately receive all rewards, which will be\ndeposited into your commission account and can be withdrawn to your wallet the next day.",
        thanks: 'Are there any wagering requirements for withdrawing rewards?',
        thanksAnswer: 'There is a one-time wagering requirement.',
        requirement: 'When can I use my rewards?',
        requirementAnswer:
          'You can withdraw your rewards to your wallet for\nspending the next day. Sometimes there may be slight\ndelays. Thank you for your understanding.',
      },
    },
    rulesPopup: {
      banner: {
        line1: 'Invite Friends Easily, Earn Commissions',
        line2: 'Continuously — Unlimited Earnings!',
      },
      agentLevel: {
        title: 'Agent Level Guide',
        you: 'You',
        a: 'A is your Level 1 Downline',
        b: 'B is your Level 2 Downline',
        c: 'C is your Level 3 Downline',
      },
      common: {
        requirements: 'Requirements:',
        rules: 'Rules:',
        successfulDeposit: 'Successful Deposit: ',
        validBettingAmount: 'Valid Betting Amount: ',
        validTurnover: 'Valid Turnover: ',
      },
      table: {
        subordinateDeposit: 'Subordinate Deposit (₹)',
      },
      faq: {
        who: {
          question: 'Q: Who are my referrals?',
          answer:
            'A: A is your Level 1 referral (direct referral). You can have an unlimited number of Level 1 referrals. B and C are your indirect referrals (non-direct referrals). All referrals beyond Level 1 are considered indirect referrals.',
        },
        benefits: {
          question: 'Q: What are the benefits of having referrals?',
          answer1:
            'A: All of your referrals can generate different types of commission rewards for you, with some commissions providing long-term recurring earnings.',
          answer2:
            'Please refer to the commission details below for the available commission types and rates.',
        },
        claim: {
          question: 'Q: How do I claim my commission rewards?',
          answer:
            'A: The system automatically settles all commission rewards every day at 06:00. After the settlement is completed, you can go to the Agent Center and click Claim to transfer your commission rewards to your account.',
        },
        example: {
          question: 'Q: Calculation Example',
          answer1:
            'A: Suppose you are now eligible to claim your agent commission rewards.',
          answer2:
            'If the valid commission amount generated by your Level 1 referrals reaches 10,000, the commission rates are as follows:',
          level1: 'Level 1 referrals: 2%',
          level2: 'Level 2 referrals: 1%',
          level3: 'Level 3 referrals: 1%',
          answer3:
            'Assume the valid commission amount generated by your Level 1, Level 2, and Level 3 referrals is 10,000 each.',
          answer4: 'Your commission reward will be calculated as:',
          formula: '10,000 × 2% + 10,000 × 1% + 10,000 × 1%',
        },
      },
      sections: {
        referral: {
          title: 'Referral Milestone Reward',
          intro:
            'Invite enough friends and meet the required conditions to claim free rewards. The more friends you invite, the greater the rewards you can earn.',
          rule1: 'Each reward tier can only be claimed once.',
          rule2:
            'The more direct referrals (Level 1 referrals) who meet the requirements, the higher the rewards you can claim.',
          rule3:
            'Please refer to the event page for the required number of referrals for each reward tier.',
        },
        deposit: {
          title: 'Deposit Commission Rebate',
          intro1:
            'When your direct referrals meet the following requirements, you will be eligible to receive agent commission rewards.',
          intro2:
            'Each time your direct referrals complete a qualified deposit, you will earn the corresponding commission reward.',
          rule1:
            'The higher the cumulative deposit amount of your direct referrals, the higher the commission rate you can earn.',
          rule2:
            'Please refer to the commission table below for detailed commission levels and rates.',
        },
        bet: {
          title: 'Bet Commission Rebate',
          intro1:
            'Once your direct referrals become valid referrals, you will be eligible to receive betting cashback rewards.',
          intro2:
            'Each time your direct referrals complete qualified valid bets, you will receive the corresponding betting cashback reward.',
          rule1:
            'The more direct referrals you invite, the higher your cashback level will be.',
          rule2:
            'Please refer to the cashback table below for detailed cashback levels and rates',
        },
      },
    },
    rule: {
      detail: {
        title: 'Rules',
        paragraph1:
          'Invite friends to register with your invitation link or code.',
        paragraph2:
          'Rewards are calculated after invited users complete eligible tasks.',
        paragraph3:
          'The reward amount is subject to the current activity rules.',
        paragraph4:
          'The platform reserves the final interpretation of this activity.',
      },
      paragraph: {
        invite: 'Invite friends to complete tasks and earn rewards.',
      },
      table: {
        people: 'People',
        invitationCount: 'Invitation count',
        rewards: 'Rewards',
      },
    },
    wheel: {
      user: 'User',
      record: 'Record',
      noRecords: 'No Records',
      rules: 'Rules',
      randomRewards: 'Random rewards',
      remainingWithdrawalTime: 'Remaining Withdrawal Time',
      withdrawAfterCollecting: 'Withdraw after collecting',
      claimItNow: 'Claim it now',
      inviteFriendsToGetFreeSpins: 'Invite friends to get free spins',
      congratulations: 'Congratulations!',
      bonusIssued: 'The bonus has been issued',
      chooseYourReward: 'Choose Your Reward',
      freeSpin: 'Free Spin',
      myAmount: 'My Amount',
      cashOut: 'Cash Out',
      only: 'Only',
      toCashOut: 'to cash out',
      inviteFriendsToGetSpin: 'Invite Friends To Get Spin',
    },
  },
  spinActual: {
    label: {
      winRecord: 'My Winning Record',
      winTime: 'Winning Time',
      orderNo: 'Order Number',
      supportToClaim: 'Contact Support to Claim',
      prize1: 'First prize',
      prize2: 'Second prize',
      prize3: 'Third prize',
      prize4: 'Fourth prize',
      prize5: 'Fifth prize',
      prize6: 'Sixth prize',
      prize7: 'Seventh prize',
      prize8: 'Eighth prize',
      prize9: 'Ninth prize',
      prizeLevel: 'Prize level',
      prizeName: 'Prize name',
    },
    tip: {
      getPrize: '{{player}} get <0>{{prize}}</0>',
      rules: {
        p1: 'Prize List:',
        p2: 'For every 1000 recharged by the user, 1 lottery spin opportunity is automatically obtained.',
        p3: 'When the single recharge amount exceeds 1000, the number of lottery spins is calculated proportionally. Amounts less than 1000 are not accumulated (e.g., recharging 2500 gets 2 spins, and the remaining 500 is not counted for the next round of accumulation).',
        p4: 'Instant issuance: After the recharge is successful, the lottery opportunity returns to the app and arrives in real time.',
        p5: 'VIP Weekly Card Purchase: Purchase the Gold Diamond Level VIP Membership Weekly Card and receive 1 chance to draw directly',
        p6: 'Validity period for physical rewards: The redemption period for physical rewards is 7 days. If the authentication operation is not completed within the validity period, the reward will be deemed invalid.',
        p7: 'Unused lottery opportunities of users are retained.',
      },
      noSpinCount: 'You have no more spins',
      spinError: 'Spin failed, please try again later!',
    },
  },
  push: {
    mainText: 'This website would like to send you awesome updates and offers!',
    secText: 'Notifications can be turned off anytime from browser settings.',
    allow: 'Allow',
    block: "Don't Allow",
  },
  promotionsV2: {
    bonus: 'Bonus',
    reward: 'Reward',
    promotion: 'Promotions',
    history: 'History',
    climb: 'Climb',
    receive: 'Receive',
    received: 'Received',
    expired: 'Expired',
    joined: '{{num}} Joined',
    join: 'Join to win',
    claimTime: 'Claim Time',
    depositAmount: 'Deposit Amount',
    bonusAmount: 'Bonus Amount',
    status: 'Status',
    congratulations: 'Congratulations !',
    getBonus: 'Get Bonus',
    claimNow: 'Claim Now',
    taskList: 'Task List',
    remainTime: 'Remaining Time',
    joinNow: 'Join Now',
    rules: 'Event Rules',
    vipLevel: 'VIP Level',
    rechargeAmount: 'Recharge Amount',
    withdrawAmount: 'Withdraw Amount',
    rechargeBonus: 'Recharge Bonus',
    details: 'Event Details',
    activityTime: 'Activity Time',
    yourCurrentRecharge: 'Your Current Recharge',
    eventRewards: 'Event Rewards',
    rewardTable: {
      amount: 'Amount',
      level: 'Level',
      bettingAmount: 'Betting Amount',
      bettingReward: 'Betting Reward',
      rechargeAmount: 'Recharge Amount',
      rechargeReward: 'Recharge Reward',
      withdrawAmount: 'Withdraw Amount',
      withdrawReward: 'Withdraw Reward',
      times: 'Times',
      rewards: 'Rewards',
    },
    cumuBets: 'Cumulative Bets',
    rechargeCount: 'Recharge Count',
    withdrawCount: 'Withdraw Count',
    prize: {
      ticket: 'Kerala lottery',
      spin: 'Lucky Spin',
    },
    type: {
      recharge: 'Recharge',
      withdraw: 'Withdraw',
      bet: 'Bet',
    },
    times: {
      1: '1st',
      2: '2nd',
      3: '3rd',
      4: '4th',
    },
    tip: {
      claim: 'Bet <0>{{amount}}</0> more to claim bonus',
      required: '<0>{{multiple}}</0> Betting Required',
      expired: 'The event has ended',
      withdraw: 'Withdraw immediately to earn',
      delete: 'Are you sure you want to delete this bonus?',
      deleteSuccess: 'Delete Successfully',
      toReceive:
        '{{type}} another <0>{{rechargeAmount}}</0> to receive a <0>{{bonusAmount}}</0> bonus',
      timeToReceive:
        '{{type}} another <0>{{rechargeAmount}}</0> more times to receive a <0>{{bonusAmount}}</0> bonus',
      completedRecharge: 'You have completed your {{times}} recharge',
      notCompleteRechargeTitle: '{{times}} Recharge',
      currentRechargeTitle: 'Your {{times}} Recharge',
      rechargeToGet: 'Recharge {{amountRange}} to get a reward of {{bonus}}',
      mustComplete:
        'You must complete the {{currentCount}} recharge to participate in the {{nextCount}} recharge event',
      notLogin: 'Please login to participate in this event',
    },
  },
  'withdraw-page': {
    unavailable: 'Withdrawal is temporarily unavailable.',
    label: {
      withdrawAmount: 'Withdraw Amount',
      received: 'Actual amount received:',
      recipientAddress: 'Recipient address:',
      receiveToken: 'Receive token:',
      transactionBreakdown: 'Transaction breakdown',
      exchangeRate: 'Real-Time Exchange Rate',
      exchangeRateTip:
        'Exchange rates fluctuate sharply. The above is for reference only; actual amount received prevails',
      processingFee: 'Processing Fee',
      selectCoin: 'Select Coin',
      estimatedUsdAmount: 'Estimated Withdrawal Amount',
    },
    error: {
      noWithdrawable: 'No withdrawable balance',
      addCard: 'Please add a bank card',
      addAmount: 'Please enter the withdrawal amount',
      selectCoin: 'Please select a coin',
      addAddress: 'Please enter the wallet address',
      invalidAddress: 'Invalid wallet address format',
      minAmount: 'Minimum withdrawal amount is {{amount}}',
      maxAmount: 'Maximum withdrawal amount is {{amount}}',
    },
    rules: {
      dailyLimit: 'Daily withdrawal limit',
      fees: 'Withdrawal fees',
      wager: 'Wager requirement',
      note1:
        'Note: withdraw may be delayed due to someBank issues. In this case, the withdrawn amount will be returned to your wallet. Thank you for your patience.',
      note2:
        'We have found some money laundry behaviorsSo limits that recharge amount should be used for betting only. The commission and winninoamount could be withdrawn immediately.',
      timesTitle: 'Daily withdrawal times',
    },
  },
  'recharge-page': {
    label: {
      exchangeRateTip:
        'Exchange rates fluctuate sharply. The above is for reference only; actual amount received prevails',
    },
  },
  rechargeProgressive: {
    webOnly: 'Recharge is only available on Web.',
    unavailable: 'Recharge is temporarily unavailable.',
  },
  paymentConfig: {
    loadFailed: 'Unable to load payment options.',
    retry: 'Retry',
  },
  rechargeGift: {
    title: 'Exclusive Recharge Gift',
    close: 'Close',
    getBonus: 'Get {{currency}} {{amount}} Bonus',
    tier: 'Gift Tier {{tier}}',
    rechargeAmount: 'Recharge amount',
    totalArrival: 'Total arrival',
    rechargeNow: 'Recharge now',
    progress: '{{current}} of {{total}} tiers completed',
    selectChannel: 'Recharge Channel',
    noChannel: 'No available recharge channel for this amount',
    confirmRecharge: 'Confirm {{currency}} {{amount}} recharge',
    confirm: 'Confirm',
    withdrawBadge: '24 Hours Withdrawal',
  },
  'vs-leaderboard': {
    modal: {
      'pity-message': "It's a pity that we didn't win this round",
      'draw-result': 'Draw Result',
      'keep-going': 'Keep Going',
    },
    title: 'Super Jackpot',
    currentIssue: 'Today',
    previousIssue: 'Yesterday',
    rules: 'Rules',
    'free-to-participate': 'Free to participate',
    'prize-pool': 'Win and claim the super prize pool',
    'draw-time': 'DRAW TIME',
    'last-jackpot-outcome': 'Last Jackpot Outcome',
    'current-jackpot': 'Current Jackpot',
    users: 'users',
    even: 'Even',
    odd: 'Odd',
    'time-left-bet-ends': 'Time left until the bet ends',
    'leaderboard-coming-soon': '{{type}} leaderboard coming soon...',
    point: 'Point',
    bonus: 'Bonus',
    invite: 'Invite',
    'faction-select-success': 'Faction selected successfully',
    youtube_player: {
      unsupported_video_format: 'Unsupported video format',
      open_in_browser: 'Open in browser',
      video_load_failed: 'Video loading failed',
      round_result: "This round's result",
      congratulations: 'Congratulations on winning!',
      finished_position:
        'You finished <positionHighlight>{{position}}</positionHighlight> in the final rankings',
      won_bonus:
        'and won a bonus of <amountHighlight>{{amount}}</amountHighlight>',
      unfortunately:
        "Unfortunately, you didn't win this round of guessing. Keep going and try again tomorrow.",
    },
  },
};
